import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const StatesContainer = ({ className, ...props }) => (
  <div
    {...props}
    className={classNames(className, styles.statesContainer)}
    data-testid="states-container"
  />
);

StatesContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

StatesContainer.displayName = "StatesContainer";

export default StatesContainer;
